import buildMeta from '../utils/buildMeta'
import { isSampleScan } from '../guards/scan'

const routes = [
  {
    name: 'scan',
    path: '/scan/:scanId',
    component: () => import('@/pages/Scan/Scan.vue'),
    meta: buildMeta({
      authRequired: false,
      robots: 'noindex',
      title: 'Scan Results - Jobscan',
      description: "Here's How Well Your Resume Matches The Job Description",
    }),
    children: [
      {
        name: 'scan-resume',
        path: '',
        component: () => import('@/pages/Scan/Resume.vue'),
        beforeEnter: [isSampleScan],
        meta: buildMeta({
          authRequired: false,
          robots: 'noindex',
        }),
      },
      {
        name: 'scan-coverletter',
        path: 'coverletter',
        component: () => import('@/pages/Scan/CoverLetter.vue'),
        beforeEnter: [isSampleScan],
        meta: buildMeta({
          authRequired: false,
          robots: 'noindex',
        }),
      },
    ],
  },
  {
    name: 'scan-poweredit',
    path: '/scan/:scanId/poweredit',
    component: () => import('@/pages/Scan/PowerEditScan.vue'),
    meta: buildMeta({
      authRequired: false,
      robots: 'noindex',
    }),
  },
]

export default routes
